import { render, staticRenderFns } from "./SPAddress.vue?vue&type=template&id=802e5fb0&"
import script from "./SPAddress.vue?vue&type=script&lang=ts&"
export * from "./SPAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports